import { NgClass, NgStyle } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Option } from '@shared/types/components.type';

import { FullSettings } from '../../../../state/category/category.query';
import {
  ForecastTableGridPeriodChange,
  ForecastTableGridTimelinePhaseInterface,
} from '../../models/forecast-table-grid.model';
import { ForecastTableGridPeriodService } from '../../services/forecast-table-grid-period.service';

@Component({
  imports: [
    TooltipDirective,
    NgStyle,
    IconComponent,
    NgSelectComponent,
    NgClass,
    FormsModule,
    NgOptionComponent,
  ],
  selector: 'aux-forecast-table-grid-period-time',
  styleUrls: ['./forecast-table-grid-period-time.component.scss'],
  templateUrl: './forecast-table-grid-period-time.component.html',
})
export class ForecastTableGridPeriodTimeComponent implements OnChanges {
  @Input() categoryId = '';
  @Input() disabled = false;
  @Input() fullSettings?: FullSettings;
  @ViewChild('gridPeriodTime') public input!: NgSelectComponent;
  @Input() isChild = false;
  @Input() isInvalid = false;
  label = '';
  @Input() onPeriodChange!: ForecastTableGridPeriodChange;
  @Input() PeriodService!: ForecastTableGridPeriodService;
  phases: Option<string>[] = [];
  @Input() placeholder = '';
  @Input() primarySettingsId = '';
  selectedPhase = '';
  @Input() timelinePhases: ForecastTableGridTimelinePhaseInterface[] = [];
  @Input() tooltip = '';

  ngOnChanges() {
    this.phases = this.PeriodService.parsePhases(this.timelinePhases, this.fullSettings);
    this.selectedPhase = this.PeriodService.parseSelectedPhase(
      this.timelinePhases,
      this.fullSettings
    );

    this.label = this.createLabel();
  }

  createLabel(): string {
    const selectedPhase = this.phases.find((phase) => {
      return phase.value === this.selectedPhase;
    });

    if (selectedPhase) {
      // Tooltip for truncated labels
      return selectedPhase.label.length > 25 ? selectedPhase.label : '';
    }

    return '';
  }

  openTimeModal(): void {
    if (this.fullSettings && !this.disabled) {
      this.onPeriodChange(this.fullSettings, {
        id: this.categoryId,
        name: !this.isChild ? 'category' : 'activity',
      });
    }
  }
}
